var map = {
	"./addTestBlind.svg": 54028,
	"./arrow.svg": 15403,
	"./bold.svg": 86559,
	"./cloud.svg": 91829,
	"./comments.svg": 42063,
	"./delete.svg": 46427,
	"./discard.svg": 1365,
	"./ellipse.svg": 77828,
	"./filter.svg": 65517,
	"./format.svg": 9477,
	"./highlight.svg": 56991,
	"./history.svg": 10552,
	"./italic.svg": 90067,
	"./line.svg": 31642,
	"./link.svg": 16207,
	"./mask.svg": 29338,
	"./padlock-locked.svg": 65723,
	"./padlock-unlocked.svg": 79510,
	"./polyline.svg": 2716,
	"./rectangle.svg": 21740,
	"./redo.svg": 10911,
	"./save.svg": 30787,
	"./screenshot.svg": 5113,
	"./shapes.svg": 44114,
	"./stamp.svg": 86873,
	"./symbol.svg": 2931,
	"./text.svg": 32669,
	"./thumbnail.svg": 81258,
	"./undo.svg": 30118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15991;